import constants from './constants.js'
import globalSettings from './global-settings.js'
import _ from '../../node_modules/underscore/underscore-min.js'
import axios from '../../node_modules/axios/dist/axios.js'

var tools = {}

// App Ready Tools
tools.alert = _.noop

// Base Tools
tools.loggedInData = function (options) {
  options = options || {}
  options.success = options.success || function (loggedInData) {
    console.log('loggedInData', loggedInData)
  }
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    })
  }

  axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/people/detail`)
       .then(response => {
         var loggedInData = (response && response.data && response.data.data && response.data.data.user) || {}

         globalSettings.authorization.data = loggedInData
         globalSettings.authorization.state.organization = {}

         var godRoleItem = _.find(loggedInData.global_roles, function (roleItem) {
           return roleItem.role_id === 13
         })

         if (godRoleItem) {
           globalSettings.authorization.state.isGod = true
         }

         if (loggedInData.organization_roles && loggedInData.organization_roles.length > 0) {
           for (var i = 0; i < loggedInData.organization_roles.length; i++) {
             var orgLabelKey = `id-${loggedInData.organization_roles[i].id}`

             if (!globalSettings.authorization.state.organization[orgLabelKey]) {
               globalSettings.authorization.state.organization[orgLabelKey] = {}
             }

             globalSettings.authorization.state.organization[orgLabelKey][`role-${loggedInData.organization_roles[i].role_id}`] = true

             if (loggedInData.organization_roles[i].role_id === 14) {
               globalSettings.authorization.state.isOrgAdmin = true

               globalSettings.authorization.state.organization[orgLabelKey].isAdmin = true
             }
           }
         }

         options.success({
           state: globalSettings.authorization.state,
           data: globalSettings.authorization.data
         })
       })
       .catch(options.error)
}

tools.signOut = function (options) {
  options = options || {}
  options.success = options.success || function (logoutData) {
    console.log('logoutData', logoutData)
  }
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    })
  }
  options.skipAPIlogout = options.skipAPIlogout || false

  var skipAPIlogout = options.skipAPIlogout

  function resetAuthData (logoutData) {
    delete axios.defaults.headers.common['Authorization']
    delete window.localStorage['prolific_authorization']
    delete window.localStorage['prolific_authorization_isGod']
    globalSettings.authorization.loggedIn = false
    globalSettings.authorization.state = {}
    globalSettings.authorization.data = {}

    options.success(logoutData)
  }

  if (skipAPIlogout) {
    resetAuthData()
  } else {
    axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/users/logout`)
         .then(response => {
           var logoutData = (response && response.data && response.data.data) || {}

           resetAuthData(logoutData)
         })
         .catch(options.error)
  }
}

tools.setupFroalaConfig = function (additionalConfig) {
  additionalConfig = additionalConfig || {}

  var resultingConfig = _.extend({}, constants.default.froala, additionalConfig)
  resultingConfig.requestHeaders = {
    Authorization: axios.defaults.headers.common['Authorization']
  }

  return resultingConfig
}

tools.getUser = function (options) {
  options = options || {}
  options.success = options.success || function () {}
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    })
  }

  var userID = options.id

  axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/options/user`, {
    params: {
      user_id: userID
    }
  })
       .then(response => {
         var userData = (response && response.data && response.data.data && response.data.data.user) || {}

         options.success(userData)
       })
       .catch(options.error)
}

tools.getOrganizationsList = function (options) {
  options = options || {}
  options.success = options.success || function () {}
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    })
  }

  axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/list`, {
    params: {
      page: 1,
      size: 50
    }
  })
       .then(response => {
         var organizationList = (response && response.data && response.data.data && response.data.data.organizations) || []

         options.success(organizationList)
       })
       .catch(options.error)
}

tools.getOrganization = function (options) {
  options = options || {}
  options.success = options.success || function () {}
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    })
  }

  var organizationID = options.id

  axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/detail`, {
    params: {
      organization_id: organizationID
    }
  })
       .then(response => {
         var organizationData = (response && response.data && response.data.data && response.data.data.organization) || {}

         options.success(organizationData)
       })
       .catch(options.error)
}

tools.getRolesList = function (options) {
  options = options || {}
  options.success = options.success || function () {}
  options.error = options.error || function (errorResponse) {
    tools.alert({
      type: 'error',
      errorResponse: errorResponse
    })
  }
  options.roleType = options.roleType || 'global'

  axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/options/roles`, {
    params: {
      role_type: options.roleType
    }
  })
       .then(response => {
         var rolesList = (response && response.data && response.data.data && response.data.data.roles) || []

         options.success(rolesList)
       })
       .catch(options.error)
}

export default tools



// WEBPACK FOOTER //
// ./src/assets/tools.js